import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import UploadFile from "./uploadRouteFile";
import { CircularProgress, Collapse, Tooltip } from "@material-ui/core";
import axios from "axios";
import "../styles/createNewRoute.scss";
import FrequencyRadioGroup from "./NewRouteInfo";
import { useNotification } from "../../Notifications/NotificationProvider";
import AlertDialog from "./alertDialog";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
const styleObject = { flexDirection: "column", textAlign: "center" };

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    display: "none",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function EditRoute({ callBack, route, agencies }) {
  const [open, setOpen] = React.useState(false);

  const [file, setFile] = React.useState(null);
  const [routeInfo, setRouteInfo] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const [alertModalData, setAlertData] = React.useState(null);
  const [showDeletePrompt, setShowDeltePrompt] = React.useState(false);
  const dispatchNotification = useNotification();

  React.useEffect(() => {
    const obj = {
      frequency: route.frequency_id.toString(),
      name: route.name,
      agency: route.agency_id,
      description: route.description,
    };

    setRouteInfo({ ...obj });
  }, [route]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    const obj = {
      frequency: route.frequency_id.toString(),
      name: route.name,
      agency: route.agency_id,
      description: route.description,
    };
    setRouteInfo({ ...obj });
    setErr(null);
  };

  const handleFile = (file) => setFile(file);
  const handleRouteInfo = (obj) => {
    setRouteInfo({ ...obj });
    //console.log(obj);
  };

  const postNewRoute = (mode) => {
    setLoading(true);
    setErr(null);
    const formData = new FormData();
    formData.append("id", route.id);
    if (file) formData.append("file", file);
    formData.append("name", routeInfo.name ? routeInfo.name : "na");
    formData.append(
      "description",
      routeInfo.description ? routeInfo.description : ""
    );
    formData.append(
      "frequency",
      routeInfo.frequency ? routeInfo.frequency : "na"
    );
    formData.append("agency", routeInfo.agency ? routeInfo.agency : "na");

    var error = null;
    ["agency", "frequency", "name"].forEach((i) => {
      if (formData.get(i) === "na") {
        error = `You must fill up the ${i} field`;
        setErr(error);
        return;
      }
    });

    if (error) {
      setLoading(false);
      return;
    } else
      axios
        .put(
          `${process.env.REACT_APP_API_URL}/api/route_management/v1/route`,
          formData,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            },
          }
        )
        .then((res) => {
          setLoading(false);
          setAlertData({ message: `Successfully ${mode} route ${route.name}` });
          dispatchNotification({
            type: "SUCCESS",
            message: `Successfully ${mode} route ${route.name}`,
          });
          //   setRouteInfo({});
          setFile(null);
          setErr(null);
          //callBack();
          setOpen(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);

          if (err.response) {
            setErr(err.response.data.message);
            dispatchNotification({
              type: "ERROR",
              message: err.response.data.message,
            });
          } else {
            dispatchNotification({
              type: "ERROR",
              message: "Something went wrong",
            });
            setErr("Something went wrong");
          }
        });
  };

  const onDeleteRoute = () => {
    const object = { id: route.id };
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/route`,

        {
          data: { ...object },
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        setLoading(false);
        setAlertData({
          message: `Route ${route.name} deactivated successfully`,
        });
        dispatchNotification({
          type: "SUCCESS",
          message: `Successfully deactivated route ${route.name}`,
        });
        setRouteInfo({});
        setShowDeltePrompt(false);
        setFile(null);
        setErr(null);
        //callBack();
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);

        if (err.response) {
          setErr(err.response.data.message);
          dispatchNotification({
            type: "ERROR",
            message: err.response.data.message,
          });
        } else {
          dispatchNotification({
            type: "ERROR",
            message: "Something went wrong",
          });
          setErr("Something went wrong");
        }
      });
  };

  return (
    <div className="edit-route-modal-container">
      <button onClick={handleClickOpen}>
        <Tooltip title={`Edit ${route.name}`} placement="right">
          <i className="material-icons right" style={{ marginLeft: 0 }}>
            edit
          </i>
        </Tooltip>
      </button>
      <AlertDialog
        data={alertModalData}
        callBackAlert={() => {
          setAlertData(null);
          callBack();
        }}
      />
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Edit route
        </DialogTitle>
        <Collapse in={showDeletePrompt}>
          <div className="delete-prompt">
            {route.mdo_count === 0 ? (
              <h2>Are you sure want to deactivate this route ?</h2>
            ) : (
              <h2>
                Please assign the field force to others before deactivating{" "}
              </h2>
            )}
            {route.mdo_count === 0 ? (
              <div className="btn-container">
                <Button onClick={onDeleteRoute} className="btn">
                  {loading && (
                    <CircularProgress
                      color={"#e2136e"}
                      size={12}
                      style={{ marginRight: 10 }}
                    />
                  )}
                  {loading ? "Deleting" : "Yes"}
                </Button>
                <Button
                  onClick={() => setShowDeltePrompt(false)}
                  className="btn"
                >
                  No
                </Button>
              </div>
            ) : (
              <div className="btn-container">
                <Button
                  onClick={() => setShowDeltePrompt(false)}
                  className="btn"
                >
                  Ok
                </Button>
              </div>
            )}
          </div>
        </Collapse>
        <Collapse in={err ? true : false}>
          <div className="err-msg">{err}</div>
        </Collapse>
        <DialogContent>
          <div
            className="route-modal-content"
            style={{
              marginTop: showDeletePrompt ? "15%" : "0%",
              opacity: showDeletePrompt ? 0.4 : 1,
              pointerEvents:
                showDeletePrompt || !route.is_active ? "none" : "auto",
            }}
          >
            <div className="new-route-info">
              <FrequencyRadioGroup
                agencies={agencies}
                routeInfo={routeInfo}
                onChangeRouteInfo={handleRouteInfo}
                mode="edit"
              />
            </div>
            <div className="upload-area">
              <UploadFile
                heading={"New route"}
                api={""}
                help={"please uplaod csv file"}
                styles={styleObject}
                onChangeFile={handleFile}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-between" }}>
          {route.is_active ? (
            <button
              className="deactivate-button"
              onClick={() => {
                setShowDeltePrompt(true);
              }}
            >
              <DeleteForeverIcon /> Deactivate
            </button>
          ) : (
            <button
              className="activate-button"
              onClick={() => postNewRoute("activated")}
            >
              {loading && (
                <CircularProgress
                  color={"#e2136e"}
                  size={12}
                  style={{ marginRight: 10 }}
                />
              )}
              {loading ? "Activating" : "Activate"} route{""}
              <i class="material-icons right" style={{ marginLeft: 6 }}>
                swap_calls
              </i>{" "}
              <b style={{ color: "#e91e63" }}>{route.name}</b>
            </button>
          )}
          {route.is_active && (
            <button
              onClick={() => postNewRoute("edited")}
              className="create-button"
            >
              {loading && (
                <CircularProgress
                  color={"#e2136e"}
                  size={12}
                  style={{ marginRight: 10 }}
                />
              )}
              {loading ? "Saving" : "Save changes"}
            </button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
